import { observable } from "mobx";
//import firebase from 'firebase';
//Deals with global variables

class UserStore {
  @observable authed = false;
  @observable email = "";
  @observable displayName = "";
  @observable photoURL = "";
  @observable uid = "";
  @observable role = "";

  //allows users to navigate app
  login() {
    this.authed = true;
  }

  //global user data
  fetchUserInfo(email, displayName, photoURL, uid) {
    this.email = email;
    this.displayName = displayName;
    this.photoURL = photoURL;
    this.uid = uid;
  }

  fetchUserRole = (roleName) => {
    // //this.role = role;
    // const adminRef = firebase.database().ref("Admin");
    // adminRef.once("value", snap => {
    //   console.log(snap.val());
    //   if(!!snap.val()){
    //     let rawData = snap.val();
    //     for(let key in rawData){
    //       console.log("key",key);
    //       console.log("rawdata[key].name", rawData[key].name);
    //       if(rawData[key].name === roleName){
    //         console.log("true");
    //         this.role = "admin";
    //         console.log(this.role);
    //       }else{
    //         this.role = "user";
    //       }
    //     }
    //   }
    // })
  }

  //resets global variable to ""
  logout() {
    this.authed = false;
    this.email = "";
    this.displayName = "";
    this.photoURL = "";
    this.uid = "";
    this.role = "";
  }
}

const userStore = new UserStore();
export default userStore;



// WEBPACK FOOTER //
// ./src/stores/UserStore.js